import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { RenderedService } from '../../rendered.service';

@Component({
    selector: 'scaffold-hidden-default',
    templateUrl: './hidden-default.component.html',
    styleUrls: ['./hidden-default.component.scss'],
    standalone: false
})
export class HiddenDefaultComponent
  extends BaseScaffoldComponent
  implements OnInit
{
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit(): void {}
}
